import { Component, PropTypes } from 'react';
import cx from 'classnames';
import _ from 'lodash';
import { names } from 'config';
import styles from './styles.css';

export default class Message extends Component {
	static propTypes = {
		message: PropTypes.shape({
			name: PropTypes.string.isRequired,
			text: PropTypes.string,
			link: PropTypes.string,
			image: PropTypes.string,
			caption: PropTypes.string,
			aside: PropTypes.object,
			isQuestion: PropTypes.bool,
			isCurator: PropTypes.bool
		}).isRequired,
		isMultiMessage: PropTypes.bool,
		onClick: PropTypes.func,
		onImageClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool])
	}

	renderImage() {
		return (
			<img className={styles.image}
				src={require(`./images/${this.props.message.image}`)}
				onClick={this.props.onImageClick} />
		);
	}

	renderVideo() {
		const { poster, mp4, webm } = this.props.message.video;
		const image = require(`./videos/${poster}`);

		const togglePlay = (event) => {
			const player = event.currentTarget;
			player[player.paused ? 'play' : 'pause']();
		};

		return (
			<div className={styles.video}>
				<video poster={image} onClick={togglePlay}>
					<source src={require(`./videos/${webm}`)} type="video/webm" />
					<source src={require(`./videos/${mp4}`)} type="video/mp4" />
					<img src={image} />
				</video>
			</div>
		);
	}

	renderText() {
		const { text, link } = this.props.message;

		return (
			<div className={styles.text}>
				{link ? <a className={styles.link} href={link} target="_blank">{text}</a> : text}
			</div>
		);
	}

	render() {
		const { isQuestion, isCurator, name, text, image, video, caption, aside } = this.props.message;
		const isMultiMessage = this.props.isMultiMessage;
		const hasModal = !!this.props.onImageClick;
		const hasAside = !!aside;

		const className = cx(styles.message, styles[`user${_.invert(names)[name]}`], {
			[styles.isQuestion]: isQuestion,
			[styles.isCurator]: isCurator,
			[styles.isMultiMessage]: isMultiMessage,
			[styles.hasModal]: hasModal,
			[styles.hasAside]: hasAside
		});

		return (
			<div className={className} onClick={this.props.onClick}>
				{name && <div className={styles.name}>{name}</div>}

				<div className={styles.messageBody}>
					{image && this.renderImage()}
					{video && this.renderVideo()}
					{text && this.renderText()}
				</div>

				{caption && <div className={styles.caption}>{caption}</div>}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Message/index.js
 **/